import { Button, Drawer, Icon } from '@ao-internal/components-react/';
import React, { useEffect, useRef, useState } from 'react';

import StaticContent from './StaticContent';

export interface DrawerComponentProps {
	openByDefault?: boolean;
	servicesContent?: ServiceContent[];
	portalTargetId: string;
	translations: Translations;
	isFiveStarMemberPricingEnabled?: boolean;
}

function DrawerComponent(props: DrawerComponentProps) {
	const [contentInSlideout, setContentInSlideOut]: any = useState(null);
	const [slideoutOpen, setSlideoutOpen] = useState(
		props.openByDefault ?? false
	);

	const slideoutRef: any = useRef(null);
	const portalTarget =
		typeof document !== 'undefined'
			? document.getElementById(props.portalTargetId)
			: undefined;
	const content = (
		<Drawer
			isOpen={slideoutOpen}
			edge="right"
			onClose={() => {
				setSlideoutOpen(false);
			}}
			closeIcon="close"
			portalTarget={portalTarget ?? undefined}
			hideCloseButton={true}
		>
			<div className="pb-6">
				<Button
					data-panel-close
					data-tag-action="close"
					data-tag-name="ProductPageServicesComponent"
					color="tertiary"
					onClick={() => setSlideoutOpen(false)}
					icon={true}
					className="py-1 px-1 pr-2 text-base -ml-3 -mt-2"
				>
					<Icon icon="chevron-left" className="text-xl" />
					{props.translations.Back}
				</Button>
			</div>
			<h2 className="text-display">{props.translations.Services}</h2>
			<StaticContent
				servicesContent={props.servicesContent}
				isFiveStarMemberPricingEnabled={props.isFiveStarMemberPricingEnabled}
			/>
		</Drawer>
	);

	useEffect(() => {
		const drawerOpenEvent = 'ProductPageServicesComponent:Open';
		const openSlideOut = () => {
			setSlideoutOpen(true);
		};

		window.addEventListener(drawerOpenEvent, openSlideOut);
		setContentInSlideOut(content);

		return function cleanup() {
			window.removeEventListener(drawerOpenEvent, openSlideOut);
		};
	}, [slideoutOpen]);

	return (
		<div id="slideout" ref={slideoutRef} data-testid="services-slide-out">
			{contentInSlideout ? (
				contentInSlideout
			) : (
				<StaticContent
					servicesContent={props.servicesContent}
					isFiveStarMemberPricingEnabled={props.isFiveStarMemberPricingEnabled}
					className={`hidden`}
				/>
			)}
		</div>
	);
}

export default DrawerComponent;
